/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { GetContactSummaryQueryResponse, GetContactSummaryPathParams, GetContactSummaryHeaderParams, GetContactSummary401 } from "../../models/contactsController/GetContactSummary";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getContactSummaryQueryKey = (contactId: GetContactSummaryPathParams["contactId"]) => [{ url: '/contacts/:contactId/summary', params: {contactId:contactId} }] as const

export type GetContactSummaryQueryKey = ReturnType<typeof getContactSummaryQueryKey>

/**
 * {@link /contacts/:contactId/summary}
 */
export async function getContactSummary(contactId: GetContactSummaryPathParams["contactId"], headers?: GetContactSummaryHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetContactSummaryQueryResponse, ResponseErrorConfig<GetContactSummary401>, unknown>({ method : "GET", url : `/contacts/${contactId}/summary`, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getContactSummaryQueryOptions(contactId: GetContactSummaryPathParams["contactId"], headers?: GetContactSummaryHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getContactSummaryQueryKey(contactId)
        return queryOptions<GetContactSummaryQueryResponse, ResponseErrorConfig<GetContactSummary401>, GetContactSummaryQueryResponse, typeof queryKey>({
         enabled: !!(contactId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getContactSummary(contactId, headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /contacts/:contactId/summary}
 */
export function useGetContactSummary<TData = GetContactSummaryQueryResponse, TQueryData = GetContactSummaryQueryResponse, TQueryKey extends QueryKey = GetContactSummaryQueryKey>(contactId: GetContactSummaryPathParams["contactId"], headers?: GetContactSummaryHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<GetContactSummaryQueryResponse, ResponseErrorConfig<GetContactSummary401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getContactSummaryQueryKey(contactId)
         

         const query = useQuery({
          ...getContactSummaryQueryOptions(contactId, headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetContactSummary401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}